export const SECTION_SLUG = "EssentialElements\\Section";
export const HEADER_BUILDER_SLUG = "EssentialElements\\HeaderBuilder";
export const GRID_SLUG = "EssentialElements\\Grid";
export const ADVANCED_SLIDER_SLUG = "EssentialElements\\Advancedslider";
export const ADVANCED_SLIDE_SLUG = "EssentialElements\\Advancedslide";
export const POPUP_SLUG = "EssentialElements\\Popup";
export const COLUMNS_SLUG = "EssentialElements\\Columns";
export const COLUMN_SLUG = "EssentialElements\\Column";
export const DIV_SLUG = "EssentialElements\\Div";
export const MISSING_ELEMENT_SLUG = "EssentialElements\\MissingElement";
export const GLOBAL_BLOCK_SLUG = "EssentialElements\\Globalblock";
export const COMPONENT_SLUG = "OxygenElements\\Component";
export const RICH_TEXT_SLUG = "EssentialElements\\RichText";
export const LEGACY_IMAGE_SLUG = "EssentialElements\\Image";
export const IMAGE_SLUG = "EssentialElements\\Image2";
export const ICON_SLUG = "EssentialElements\\Icon";
export const OXY_IMAGE_SLUG = "OxygenElements\\Image";
export const LINK_SLUG = "EssentialElements\\TextLink";
export const WRAPPER_LINK_SLUG = "EssentialElements\\WrapperLink";
export const BUTTON_SLUG = "EssentialElements\\Button";
export const GALLERY_SLUG = "EssentialElements\\Gallery";
export const WP_MENU_SLUG = "EssentialElements\\WpMenu";
export const VIDEO_SLUG = "EssentialElements\\Video";
export const FORM_BUILDER_SLUG = "EssentialElements\\FormBuilder";
export const LOGO_LIST_SLUG = "EssentialElements\\LogoList";
export const TEXT_SLUG = "EssentialElements\\Text";
export const HEADING_SLUG = "EssentialElements\\Heading";

export const spacingBarsPresetSlug = [
  "spacing_all_y",
  "spacing_all_x",
  "spacing_all",
  "spacing_all_not_responsive",
  "spacing_margin_all",
  "spacing_margin_y",
  "spacing_margin_x",
  "spacing_padding_all",
  "spacing_padding_y",
  "spacing_padding_x"
] as const;

export type SpacingBarSlugs = (typeof spacingBarsPresetSlug)[number];
